import i18next from "../../../i18n";

i18next.addResourceBundle("en", "SearchFilter", {
    placeholder: "Search",
});

i18next.addResourceBundle("fr", "SearchFilter", {
    placeholder: "Rechercher",
});
